import { render, staticRenderFns } from "./home-title.vue?vue&type=template&id=1e56636d&scoped=true"
import script from "./home-title.vue?vue&type=script&lang=js"
export * from "./home-title.vue?vue&type=script&lang=js"
import style0 from "./home-title.vue?vue&type=style&index=0&id=1e56636d&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e56636d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jenkins/.jenkins/workspace/web-douhua-mcn-pc/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1e56636d')) {
      api.createRecord('1e56636d', component.options)
    } else {
      api.reload('1e56636d', component.options)
    }
    module.hot.accept("./home-title.vue?vue&type=template&id=1e56636d&scoped=true", function () {
      api.rerender('1e56636d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/home/components/home-title.vue"
export default component.exports